import React from 'react'
import ReactModal from 'react-modal'
import { Button } from '../../../../shared/components/button/button'

export function TermsModal({
  isOpen,
  onClose,
  onAccept,
  termsVersion,
  termsContent,
}) {
  return (
    <ReactModal
      isOpen={isOpen}
      className={'pix-modal'}
      overlayClassName={'overlay-pix-modal'}
      ariaHideApp={false}
    >
      {/* HEADER */}
      <div className="pix-modal-header">
        <h1>Termos e Condições – Pix Parcelado</h1>
      </div>

      {/* BODY */}
      <div className="pix-modal-body">
        <div className="col-md-12">
          <p className="mb-2">
            Antes de prosseguir, leia atentamente os termos abaixo.
          </p>

          <p
            className="terms-box"
            style={{
              maxHeight: '300px',
              overflowY: 'auto',
              padding: '15px',
              borderRadius: '4px',
              backgroundColor: '#f5f5f5',
              color: '#000',
              whiteSpace: 'pre-wrap',
              width: '100%',
            }}
          >
            {termsContent}
          </p>

          <p className="mt-2">
            Versão do termo: <strong>{termsVersion}</strong>
          </p>
        </div>
      </div>

      {/* FOOTER */}
      <div className="pix-modal-footer">
        <Button variant="secondary" size={'sm'} onClick={onClose}>
          Fechar
        </Button>

        <Button variant="primary" size={'md'} onClick={onAccept}>
          Aceitar Termos
        </Button>
      </div>
    </ReactModal>
  )
}
